export default Object.freeze({
  FinalResolution: 7,
  TotalAgreement: 4,
  WithDrawal: 5,
  Rejection: 6,
  Amended: 8,
});
